import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EAsyncStatus, GreenroomState } from '../../../stores/types/types';
import { setModalOpen } from '../../../stores/actions/modal';
import { DeleteMeeting } from '../../../connection/meeting';
import WaitingIndicator from '../../general-components/waiting-indicator';
import { loadMeetingsStandaloneGreenroomProducer } from '../../../stores/actions/content';

interface IDeleteEventConfirmationProps {
    meeting: { [key: string]: any };
}

export default function DeleteEventConfirmation({ meeting: { meeting } }: IDeleteEventConfirmationProps) {
	const dispatch = useDispatch();
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);

    const [status, setStatus] = useState(EAsyncStatus.Incomplete);

    const closeModal = () => {
        dispatch(setModalOpen(false))
    };
    
    const deleteShow = async () => {
        if (token && meeting) {
            setStatus(EAsyncStatus.Waiting);

            const { id } = await DeleteMeeting(token, meeting);

            if (!id) {
                setStatus(EAsyncStatus.Error);
            } else {
                setStatus(EAsyncStatus.Complete);

                // Reload events after changes
                dispatch(loadMeetingsStandaloneGreenroomProducer(token));
            }

            closeModal();
        }
    };

	return (
		<div className="info-modal confirmation-dialog delete-event">
			<h4>Are you sure you want to delete this show?</h4>
            <div className="text-content">All the content will be lost.</div>
            <div className="button-group">
                <button
                    className="gray"
                    onClick={deleteShow}
                >
                    {status === EAsyncStatus.Waiting ? (
                        <WaitingIndicator />
                    ) : (
                        <>Delete show</>
                    )}
                </button>
                <button
                    className="green"
                    onClick={closeModal}
                >
                    Cancel
                </button>
            </div>
		</div>
	)
}
